import { Component, inject, signal } from '@angular/core';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';

import { InstalarAppService } from '../../../core/services/instalar-app.service';

@Component({
  selector: 'app-instalar-app-boton',
  standalone: true,
  imports: [Button, Dialog],
  templateUrl: './instalar-app-boton.component.html',
})
export class InstalarAppBotonComponent {
  readonly instalarApp = inject(InstalarAppService);
  readonly instruccionesIos = signal(false);

  instalar(): void {
    if (this.instalarApp.modo() === 'ios') {
      this.instruccionesIos.set(true);
      return;
    }
    void this.instalarApp.instalarAndroid();
  }
}
